import { Navigate } from 'react-router';

export default function OLGRedirect() {
  return (
    <Navigate to="/events/our-long-goodbye" />
  )
}